<template>
  <div class="container-pc">
    <div class="content-pc">
      <div class="box-card left-card" :body-style="{ padding: 0 }">
        <div class="subsection-box">
          <div
            class="subsection-item"
            v-for="_subsection in subsectionList"
            :key="_subsection.value"
            :class="{ subsectionActive: filteredConditions?.value === _subsection.value }"
            @click="handleSubsection(_subsection)"
          >
            {{ _subsection.label }}
          </div>
        </div>
      </div>
      <div class="right-card">
        <a-card class="box-card top-card">
          <div class="select-box" v-if="subsectionValue !== 'HIGH_SCHOOL'">
            <span>年级：</span>
            <div class="selections">
              <div
                v-for="_grades in filteredConditions?.grades"
                :key="_grades.value"
                :class="{ active: _grades.value === selectedCondition.grade }"
                @click="handleGrade(_grades.value)">{{ _grades.label }}
              </div>
            </div>
          </div>
          <div class="select-box">
            <span>科目：</span>
            <div class="selections">
              <div
                v-for="_subjects in filteredConditions?.subjects"
                :key="_subjects.value"
                :class="{ active: _subjects.value === selectedCondition.subject }"
              >{{ _subjects.label }}</div>
            </div>
          </div>
          <div class="select-box">
            <span>版本：</span>
            <div class="selections">
              <div
                v-for="_versions in filteredConditions?.versions"
                :key="_versions"
                :class="{ active: _versions === selectedCondition.version }"
                @click="handleVersion(_versions)">{{ _versions }}
              </div>
            </div>
          </div>
          <!-- <div class="material-name-box">
            <div>教辅：</div>
            <a-input
              style="width: 186px; height: 30px"
              v-model="materialName"
              placeholder="请输入教辅名称"
              @change="getMaterialName"
            />
          </div> -->
        </a-card>
        <a-card class="box-card bottom-card">
          <a-spin :spinning="loading">
            <a-row :gutter="20" v-if="materialList && materialList.length > 0">
              <a-col
                :span="24"
                :xxl="8"
                :xl="12"
                v-for="item in materialList"
                :key="item.id"
              >
                <div class="homework-box">
                  <div class="left-img">
                    <img :src="item.url" alt="封面加载失败" />
                  </div>
                  <div class="right-info">
                    <div class="big-title">
                      <div class="name" v-if="item.name">
                        {{ item.name }}
                      </div>

                      <!-- <div class="entrainment-tag">
                        含夹卷
                      </div> -->
                    </div>
                    <div class="text-item material-title">
                      <div class="block"></div>
                      <div>
                        {{ item.standardName ? item.standardName : "-" }}
                      </div>
                    </div>
                    <div class="text-item" v-if="item.gradeName">
                      年级：{{ item.gradeName ? item.gradeName : "-" }}
                    </div>
                    <div class="text-item">
                      科目：{{ item.subjectName ? item.subjectName : "-" }}
                    </div>
                    <div class="text-item">
                      创建时间：{{ item.createTime ? item.createTime : "-" }}
                    </div>
                    <div class="see-audio" v-if="item.audioUrl">
                      <!-- <div @click="handleDownAudio(item)">下载音频</div> -->
                      <a class="btn" :href="item | genDownloadUrl('听力')">下载音频</a>

                      <a class="btn" @click="viewAnswer(item)">查看听力</a>
                    </div>
                    <div class="no-audio" v-else>暂无听力</div>
                  </div>
                </div>
              </a-col>
            </a-row>
            <div v-else class="no-data">
              <a-empty description="暂无数据" />
            </div>
          </a-spin>
        </a-card>
      </div>
    </div>
    <template v-if="isShowAnswer">
      <ui-anser @change="toReturn" :value="answerValue" />
    </template>
  </div>
</template>

<script>
import UiAnser from "./ui-answer.vue"
import { getMaterialList, getMaterialCondition } from "@/api/material.js"
import { getSubsectionName, getGradeName, getSubjectName, debounce } from "@/utils/filter.js"
import { genDownloadUrl } from "../utils.js"

export default {
  components: {
    UiAnser,
  },
  data() {
    return {
      loading: false,
      isShowAnswer: false,
      answerValue: null,
      subsectionList: [],
      filteredConditions: null,
      subsectionValue: null,
      selectedCondition: {
        grade: null,
        subject: "ENGLISH",
        version: '全部版本'
      },
      materialList: []
      // materialName: null
    };
  },
  created() {
    this.getConditions()
  },
  filters: {
    genDownloadUrl,
  },
  methods: {
    // 获取教辅筛选条件详情
    getConditions() {
      this.subsectionList = []
      getMaterialCondition().then((res) => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.subsectionList.push({
              label: getSubsectionName(item.subsection),
              value: item.subsection,
              grades: item.conditionInfo?.grades.map(_grades => {
                return {
                  label: getGradeName(_grades),
                  value: _grades
                }
              }) || [],
              subjects: [{
                label: getSubjectName("ENGLISH"),
                value: "ENGLISH"
              }],
              versions: item.conditionInfo?.subjectVersion['ENGLISH'] || [],
            })
          })
          this.addAllSelection()
          this.filteredConditions = this.subsectionList[0]
          this.getMaterialList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error("服务器异常，加载数据失败")
      })
    },
    // 选择学段
    handleSubsection(_sub) {
      if (this.filteredConditions?.value === _sub.value) return
      this.filteredConditions = _sub
      this.subsectionValue = _sub.value
      this.init()
      this.getMaterialList()
    },
    // 选择年级
    handleGrade(value) {
      this.selectedCondition.grade = value
      this.getMaterialList()
    },
    // 选择版本
    handleVersion(value) {
      this.selectedCondition.version = value
      this.getMaterialList()
    },
    // 初始化
    init() {
      this.selectedCondition = {
        grade: null,
        subject: "ENGLISH",
        version: '全部版本'
      }
    },
    handleDownAudio (item) {
      window.open(item.audioUrl)
    },
    viewAnswer(item) {
      this.answerValue = item
      this.isShowAnswer = true
    },
    getMaterialList() {
      const { grade, subject } = this.selectedCondition,
            version = this.selectedCondition.version === '全部版本' ? null : this.selectedCondition.version,
            subsection = this.filteredConditions.value

      this.loading = true
      this.materialList = []
      getMaterialList({ grade, subject, version, subsection }).then((res) => {
        if (res.code === 0) {
          this.materialList = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error("服务器异常，加载数据失败")
      }).finally(() => {
        this.loading = false
      });
    },
    toReturn() {
      this.isShowAnswer = false
    },
    // 筛选添加全部选项
    addAllSelection() {
      this.subsectionList.forEach(info => {
        let { grades, versions } = info
        grades.unshift({ label: "全部年级", value: null })
        versions.unshift("全部版本")
      })
    },
    // getMaterialName: debounce(function () {
    //   this.getDataList();
    // }, 800),
  },
};
</script>

<style lang="less">
.container-pc {
  padding: 10px;
  background-color: #F5F5F5;
  .content-pc{
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .left-card {
    width: 200px;
    height: calc(100vh - 20px);
    padding: 20px;
    border-right: 1px solid rgb(235, 233, 233);
    .subsection-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .subsection-item {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        transition: 0.3s;
        cursor: pointer;
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        position: relative;
      }
      .subsectionActive {
        transition: 0.3s;
        color: #28b8ba;
        background-color: rgba(40, 184, 186, 0.2);
      }
    }
  }
  .right-card {
    display: flex;
    flex-direction: column;
    width: calc(100% - 200px);
    height: calc(100vh - 20px);
    .top-card {
      border-bottom: 1px solid rgb(235, 233, 233);
      .ant-card-body {
        padding-bottom: 14px;
        & > div:last-child {
          margin-bottom: 0 !important;
        }
      }
      .select-box {
        display: flex;
        align-items: flex-start;
        font-size: 16px;
        color: #000;
        margin-bottom: 10px;
        & > span {
          display: block;
          padding-top: 3px;
          margin-right: 10px;
          width: 40px;
          white-space: nowrap;
        }
        .selections {
          flex: 1;
          div {
            display: inline-block;
            padding: 2px 10px;
            margin-bottom: 10px;
            text-align: center;
            cursor: pointer;
            border: 1px solid #fff;
            &.active {
              font-weight: 500;
              color: #18C2C2;
              border-radius: 4px;
              border-color: #18C2C2;
              background: #E7F9F9;
            }
          }
        }
      }
    }

    .bottom-card {
      flex: 1;
      overflow: auto;
      .ant-card-body {
        padding-bottom: 4px;
      }
    }
    .homework-box {
      border: 1px solid #F8F9FA;
      background-color: #F8F9FA;
      padding: 10px;
      border-radius: 6px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    .homework-box:hover {
      border-color: #fa7837;
    }
    .left-img {
      width: 160px;
      height: 220px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .right-info {
      width: calc(100% - 175px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .big-title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .name{
          font-size: 18px;
          font-weight: 600;
          color: #000;
        }
        .entrainment-tag{
          font-size: 14px;
          padding: 2px 10px;
          background-color: #28b8ba;
          color: #fff;
          border-radius: 4px;
          white-space: nowrap;
        }
      }
      .material-title{
        color: #FA6400 !important;
        font-weight: 600 !important;
        display: flex;
        align-items: center;
        .block{
          width: 5px;
          height: 5px;
          background-color: #FA6400;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .text-item {
        font-size: 13px;
        color: #666666;
        font-weight: 500;
      }
      .see-audio {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        
        .btn {
          font-size: 14px;
          color: #0a71b6;
          padding: 4px 12px;
          border-radius: 18px;
          border: 1px solid #0a71b6;
          cursor: pointer;
        }
      }
      .no-audio {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}
.box-card {
  border: none;
}
.no-data {
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
